import * as React from 'react';
const FieldsOrder = React.memo((props) => {
    let childsArray = React.Children.toArray(props.children);
    if (props.reverse) {
        childsArray = childsArray.reverse();
    }
    return React.createElement(React.Fragment, null, childsArray);
});
export default FieldsOrder;
